module.exports = __webpack_public_path__ + "img/AUT.bceade6.svg";